module.exports = __webpack_public_path__ + "static/media/ISTP.61754f23.png";